import { BuildingDTO } from "./building";
import { FileLog } from "./file";

export enum BuildingSubsidenceStatus {
  OK = "Geen verzakkingen",
  NOT_OK = "Verzakkingen vastgesteld",
  UNKNOWN = "Nog na te kijken",
}

export enum BuildingCracksAndFissuresStatus {
  OK = "Geen barsten en scheuren",
  NOT_OK = "Wel barsten en scheuren",
  UNKNOWN = "Nog na te kijken",
}

export enum BuildingRoofStabilityStatus {
  OK = "Geen doorbuiging of aantasting",
  NOT_OK = "Wel doorbuiging of aantasting",
  UNKNOWN = "Nog na te kijken",
}

export enum BuildingFloorStabilityStatus {
  OK = "Geen doorbuiging, gaten, barsten of scheuren",
  NOT_OK = "Wel doorbuiging, gaten barsten of scheuren",
  UNKNOWN = "Nog na te kijken",
}

export enum BuildingChimneyStabilityStatus {
  OK = "Geen doorhelling, gaten, losse stenen of open voegen",
  NOT_REQUIRED = "Geen schoorsteen aanwezig",
  NOT_OK = "Wel doorhelling, gaten, losse stenen of open voegen",
  UNKNOWN = "Nog na te kijken",
}

export enum RainWaterPipesStatus {
  OK = "Geen zichtbare schade, buizen sluiten goed af",
  NOT_OK = "Wel zichtbare schade of slechte afdichting",
  UNKNOWN = "Nog na te kijken",
}

export enum ProtectionUnderRoofStatus {
  OK = "Onderdak aanwezig",
  NOT_REQUIRED = "Andere bescherming tegen waterinfiltratie aanwezig",
  NOT_OK = "Geen onderdak aanwezig",
  UNKNOWN = "Nog na te kijken",
}

export enum RoofStatus {
  OK = "Dakbedekking (en onderdak) in goede staat",
  NOT_OK = "Dakbedekking (of onderdak) vertonen schade",
  UNKNOWN = "Nog na te kijken",
}

export enum StairStatus {
  OK = "Veilige trappen, inclusief trapspijlen en leuningen",
  NOT_OK = "Onveilige trappen, ontbrekende trapspijlen of leuningen",
  NOT_REQUIRED = "Geen trap in het gebouw",
  UNKNOWN = "Nog na te kijken",
}

export enum BuildingConcreteStatus {
  OK = "Betonconstructies in goede staat",
  NOT_REQUIRED = "Geen betonconstructies aanwezig",
  NOT_OK = "Betonrot of scheuren in beton vastgesteld",
  UNKNOWN = "Nog na te kijken",
}

export enum SteelGirdersStatus {
  OK = "Stalen liggers in goede staat",
  NOT_REQUIRED = "Geen stalen liggers aanwezig",
  NOT_OK = "Roest of constructieve schade aan liggers vastgesteld",
  UNKNOWN = "Nog na te kijken",
}

export enum AsbestosPresentStatus {
  OK = "Geen asbest aanwezig",
  SUSPICION_PRESENT = "Sterk vermoeden asbest aanwezig",
  NOT_OK_LESS_URGENT = "Asbest aanwezig, te verwijderen bij renovatie",
  NOT_OK_URGENT = "Asbest aanwezig, dringend te verwijderen",
  UNKNOWN = "Onbekend / Nog na te kijken",
}

export enum LeadPresentStatus {
  OK = "Geen lood aanwezig",
  NOT_OK = "Loden buizen aanwezig",
  UNKNOWN = "Onbekend / Nog na te kijken",
}

export enum DoorbellType {
  CLASSIC = "Klassieke deurbel, zonder video",
  VIDEO = "Deurbel met videofonie",
  NOT_OK = "Geen deurbel aanwezig of niet werkend",
  UNKNOWN = "Onbekend / Nog na te kijken",
}

export enum GutterStatus {
  OK = "Geen zichtbare schade",
  NOT_OK = "Wel zichtbare schade of verouderd",
  UNKNOWN = "Nog na te kijken",
}

export type BuildingInspectionInfo = {
  id: number;
  building: BuildingDTO;

  /* Stability */
  buildingConcreteStatus: BuildingConcreteStatus;
  buildingConcreteStatusDescription: string;
  steelGirdersStatus: SteelGirdersStatus;
  steelGirdersStatusDescription: string;
  stabilityfileLogIds: number[];
  stabilityfileLogs: FileLog[];
  buildingSubsidences: BuildingSubsidenceStatus; // Verzakkingen
  buildingSubsidencesDescription: string; // Verzakkingen beschrijving locatie
  buildingCracksAndFissures: BuildingCracksAndFissuresStatus;
  buildingCracksAndFissuresDescription: string;
  buildingRoofStabilityStatus: BuildingRoofStabilityStatus;
  buildingFloorStabilityStatus: BuildingFloorStabilityStatus;
  buildingChimneyStabilityStatus: BuildingChimneyStabilityStatus;
  stairWidth: string;

  /* Visual Inspection */
  rainWaterPipesStatus: RainWaterPipesStatus;
  protectionUnderRoofStatus: ProtectionUnderRoofStatus;
  roofStatus: RoofStatus;
  stairStatus: StairStatus;
  roofStatusDescription: string;

  dangerousMaterialDocumentsFileLogIds: number[];
  dangerousMaterialDocumentsFileLogs: any[];
  asbestosPresentStatus: AsbestosPresentStatus;
  leadPresentStatus: LeadPresentStatus;
  doorbellType: DoorbellType;
  doorbellBrand: string;
  doorbellModel: string;
  gutterStatus: GutterStatus;
};
